import React, { Component } from 'react';
import { FormGroup, Input, Button, Badge, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import localStorageCustom from '../../utilitarios/localStorage';
import { data } from '../../constants/Constants';
import { BuscarPrePedido, AbrirPrePedido } from '../../store/sagas/pedidoApi';
import { notificacion, getStatePage } from '../../utilitarios/util';
import Spinner from "../reusable/Loader";

export class PrePedidos extends Component {
  static displayName = PrePedidos.name;

  constructor(props) {
    super(props);
    this.state = {
      dealer: {},
      linea: {},
      asociado: {},
      loading: true,
      prepedidos: [],
      prepedidosFiltrados: []
    };
  }

  load = () => {
    let data = localStorageCustom.prototype.getUsuario();
    this.setState({ loading: true, dealer: data.dealer, linea: data.linea, asociado: data.asociado }, () => {
      this.postBuscarPrePedido();
    })
  }

  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0)
      this.load();
    } else
      window.location.href = "/";
  }

  render() {
    const { loading, prepedidos, prepedidosFiltrados, alertas, search } = this.state;
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>PRE -  Pedidos</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li>PRE -  Pedidos</li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <h6 className="title white mobile px-5">
            <a onClick={() => this.props.history.goBack()} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></a>
            PRE-Pedidos
          </h6>
          <div className="card">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
            <FormGroup className="icon mb-4 w-100" style={{ maxWidth: 255, margin: 'auto' }}>
              <Input className="" type='text' placeholder="Descripción"
                value={search}
                onChange={(text) => this.searchPedido(text)}
              />
              <Button color="link" className="btn-icon">
                <SvgAssets icon='icon-lupa' fill={c.azulClaro} />
              </Button>
            </FormGroup>
            <hr className="desktop my-4" style={{ borderColor: '#E2E2E2' }} />
            <h6 className="paragraph-2 text-left w-100 mx-auto light mb-3" style={{ maxWidth: 440 }}>Resultados ({prepedidosFiltrados.length})</h6>
            {prepedidosFiltrados.map((item, index) => {
              return (
                <div className="card_product_horizontal card_local" key={index}>
                  <div className="cphCounterInput" style={{ backgroundColor: c.verdeClaro }}>
                    <button className="btn-icon"
                      type="button"
                      onClick={() => this.IrCarrito(item.pedidoId, item.localId)}
                    >
                      <SvgAssets icon="icon-edit" fill="#fff" />
                    </button>
                  </div>
                  <div className="cphTextCenter">
                    <span className="paragraph-3 light">Fecha de Pre-Pedido {item.fechaCorta}</span>
                    <h6 className="paragraph-2 bold mb-0" style={{ color: c.verdeClaro }}>Pedido a {item.direccion}</h6>
                    {item.alias != "" && item.alias != null ?
                      <h6 className="paragraph-2 bold mb-0" style={{ color: c.azulClaro }}>
                        {/* <SvgAssets icon="icon-local" fill={c.azulClaro} className="mr-1" /> */}
                        {item.alias}
                      </h6>
                      : null}
                    <span className='paragraph-2 bold' style={{ color: c.azulClaro }}>Transportista {item.transportista}</span>
                    <span className='paragraph-2 light' style={{ color: c.azulClaro }}>Pedido lo recibe: {item.contacto}</span>
                  </div>
                </div>
              )
            })}
            {/* <div className="card_product_horizontal">
              <div className="cphCounterInput" style={{ backgroundColor: c.verdeClaro }}>
                <button className="btn-icon"><SvgAssets icon="icon-edit" fill="#fff" /></button>
              </div>
              <div className="cphTextCenter">
                <span className="paragraph-3">Fecha de Pre-Pedido 18/08 - 08:00 am</span>
                <h6 className="paragraph-2 bold mb-0" style={{ color: c.verdeClaro }}>Pedido a San Isidro - Begonias</h6>
              </div>
            </div>
            <div className="card_product_horizontal">
              <div className="cphCounterInput" style={{ backgroundColor: c.verdeClaro }}>
                <button className="btn-icon"><SvgAssets icon="icon-edit" fill="#fff" /></button>
              </div>
              <div className="cphTextCenter">
                <span className="paragraph-3">Fecha de Pre-Pedido 16/08 - 08:00 am</span>
                <h6 className="paragraph-2 bold mb-0" style={{ color: c.verdeClaro }}>Pedido a Calle camilo carrillo N°218</h6>
              </div>
            </div> */}
          </div>
        </Container>
      </div>
    );
  }

  searchPedido = (e) => {
    let text = e.currentTarget.value;
    let data = this.state.prepedidos;
    if (text) {
      let textData = text.toUpperCase();
      let newData = data.filter(function (item) {
        const itemData = (item.direccion == null ? "" : item.direccion).toUpperCase();
        const itemAlias = (item.alias == null ? "" : item.alias).toUpperCase();
        if (itemAlias.indexOf(textData) > -1) return item;
        if (itemData.indexOf(textData) > -1) return item;
      });
      console.log("prepedidosFiltrados==>", newData);
      this.setState({ prepedidosFiltrados: newData });
    } else {
      console.log("data==>", data);
      this.setState({ prepedidosFiltrados: data });
    }
  }

  IrCarrito = async (pedido, local) => {
    AbrirPrePedido(this.state.dealer, pedido)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false
          }, async () => {
            let datosBuscador = { localId: local }
            this.props.history.push({ pathname: 'carrito', state: { datosBuscador } });
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Carrito", error.message ?? null);
        });
      });

  }
  postBuscarPrePedido = async () => {
    BuscarPrePedido(this.state.dealer, this.state.linea, this.state.asociado, this.state.localId)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            prepedidos: result.dto.prePedidos,
            prepedidosFiltrados: result.dto.prePedidos,
            alertas: result.dto.alertas
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Carrito", error.message ?? null);
        });
      });
  }
}
